<p-messages severity="warn" styleClass="my-0" data-cy="item-quantity-validation-message">
  <ng-template pTemplate>
    <div class="flex align-content-start">
      <i class="mi-round mi-warning p-message-icon warning-icon"></i>
      <div class="flex flex-column align-items-start text-black-base">
        <div class="flex flex-column">
          <p *ngIf="title" class="p4 mt-0 mb-2 font-bold" data-cy="item-quantity-validation-title">
            {{ title }}
          </p>
          <div
            class="p4 my-0"
            [ngClass]="isExpanded ? '' : 'truncated'"
            [innerHTML]="messageHtml"
            data-cy="item-quantity-validation-details"
          ></div>
        </div>
        <button
          pButton
          type="button"
          [label]="isExpanded ? 'Show less' : 'Show more'"
          [icon]="isExpanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
          iconPos="right"
          class="p-button-text p-button-sm toggle-expand-button"
          (click)="toggleExpand()"
          data-cy="toggle-expand-button"
        ></button>
      </div>
    </div>
  </ng-template>
</p-messages>
